import { type } from 'arktype';

export const TEAM_WORKING_DAYS_LIMITS = {
  PERSON_BATCH_SIZE: 50,
  MAX_RANGE_DAYS: 92,
} as const;

export const teamWorkingDaysQuerySchema = type({
  from: type('string').configure({
    description: 'Required. First date of the range (YYYY-MM-DD, inclusive).',
    examples: ['2026-04-13'],
  }),
  to: type('string').configure({
    description: 'Required. Last date of the range (YYYY-MM-DD, inclusive). The inclusive range is capped at 92 days.',
    examples: ['2026-04-19'],
  }),
}).configure({ description: 'Query parameters for the team working-days endpoint.' });

export interface TeamWorkingDaysQuery {
  from: string;
  to: string;
}

export const teamWorkingDaySchema = type({
  date: 'string',
  working: 'boolean | null',
  'locationId?': 'string | null',
  'locationType?': "'physical'|'virtual'|null",
});

export const teamWorkingDaysPersonSchema = type({
  personId: 'string',
  dates: teamWorkingDaySchema.array(),
});

export const teamWorkingDaysResponseSchema = type({
  data: teamWorkingDaysPersonSchema.array(),
});
export interface TeamWorkingDay {
  date: string;
  working: boolean | null;
  locationId?: string | null;
  locationType?: 'physical' | 'virtual' | null;
}

export interface TeamWorkingDaysPerson {
  personId: string;
  dates: TeamWorkingDay[];
}

export interface TeamWorkingDaysResponse {
  data: TeamWorkingDaysPerson[];
}
